export interface ValidationMsg {
	formControlName?: string;
	msg: string;
}

export const STANDARD_ERROR_MAP: { [validationKey: string]: ValidationMsg[] } = {
	required: [{msg: 'validations.required'}],
	minlength: [{msg: 'validations.minlength'}],
	maxlength: [{msg: 'validations.maxlength'}],
	empty: [{msg: 'validations.empty'}],
	min: [{msg: 'validations.min'}, {msg: 'validations.min-employees', formControlName: 'employeesCount'}],
	max: [{msg: 'validations.max'}, {msg: 'validations.max-employees', formControlName: 'employeesCount'}],
	email: [{formControlName: 'email', msg: 'validations.email'}, {msg: 'validations.email'}],
	integer: [{msg: 'validations.integer'}],
	nbDatepickerParse: [{msg: 'Incorrect date'}],
	radiobuttonRequired: [{msg: 'validations.radiobuttonRequired'}]
};
